import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const biSiteVisitsRequest = createRequest(constants.biSiteVisits);
export const biSiteVisitsSuccess = createSuccess(constants.biSiteVisits);
export const biSiteVisitsFailure = createFailure(constants.biSiteVisits);

export const biSiteVisitsBySiteAndDateRequest = createRequest(constants.biSiteVisitsBySiteAndDate);
export const biSiteVisitsBySiteAndDateSuccess = createSuccess(constants.biSiteVisitsBySiteAndDate);
export const biSiteVisitsBySiteAndDateFailure = createFailure(constants.biSiteVisitsBySiteAndDate);

export const biSiteVisitsByDateRequest = createRequest(constants.biSiteVisitsByDate);
export const biSiteVisitsByDateSuccess = createSuccess(constants.biSiteVisitsByDate);
export const biSiteVisitsByDateFailure = createFailure(constants.biSiteVisitsByDate);

export const setLoadingState = createAction(constants.setLoadingState);

export const requestBISiteVisits = biSiteVisitsRequest;
export const requestBISiteVisitsBySiteAndDate = biSiteVisitsBySiteAndDateRequest;
export const requestBISiteVisitsByDate = biSiteVisitsByDateRequest;
